import React from 'react';

type Props = {
    side: 'left' | 'right';
    onPointerDown: (e: React.PointerEvent<HTMLDivElement>) => void;
};

/**
 * Presentational resize edge handle (Radix-style: behavior injected via props).
 */
export const SubtitleResizeHandle: React.FC<Props> = ({ side, onPointerDown }) => (
    <div
        className={`subtitle-resize-handle subtitle-resize-handle--${side}`}
        onPointerDown={onPointerDown}
        role="separator"
        aria-orientation="vertical"
        tabIndex={-1}
    />
);
